import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class notificationOptOut_template extends vnTemplate {

    protected getTemplateHtml(): string{

        return `
            <div class="promo-wrapper">
                <div class="promo-body">

                    <div class="w-form" id="processing-token" data-bind="style: {display: processingToken}">
                        <div class="form-header">
                            <h3 class="form-title logo">Validating</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group load">
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='40' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='100' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='160' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg>
                            </div>
                            <div class="form-group">
                                <p class="form-text">Please hold on while we validate your request. This process may take a moment.</p>
                            </div>

                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>

                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>

                    <div class="w-form" id="invalid-token" data-bind="style: {display: invalidToken}">
                        <div class="form-header">
                            <h3 class="form-title logo">Invalid request</h3>
                        </div>
                        <div class="form-body" style="padding-top: 1.5rem;">
                            <div class="form-group">
                                <p class="form-text">Something went wrong.</p>
                            </div>
                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>

                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>

                    <div class="w-form" id="welcome" data-bind="style: {display: optOutComplete}">
                        <div class="form-header">
                            <h3 class="form-title logo">You have been unsubscribed</h3>
                        </div>
                        <div class="form-body" style="padding-top: 1.5rem;">
                            <div class="form-group">
                                <p class="form-text">You’ve been unsubscribed. <br>We’re sorry to see you go!</p>
                            </div>
                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>

                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>
                </div>

                <footer class="default-footer">
                    <div>
                        <div class="default-footer-left">
                            <a href="/"><img src="/assets/images/logo-mark-white.svg" alt="Logo"></a>
                            <ul>
                                <li><a onclick="window.location.assign('https://sentinelpro.com')">Home</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/pricing')">Pricing</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/contact')">Contact</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/privacy-policy')">Privacy Policy</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/terms-and-services')">Terms and Services</a></li>

                            </ul>
                        </div>
                        <div class="default-footer-right">
                            <p>&copy; 2025 ValServ Inc. All rights reserved.</p>
                        </div>
                    </div>
                </footer>
            </div>
            `;
    }

    protected getTemplateName(): string{
        return "notificationOptOut_template";
    }

    protected initPartial(): void{
    }

    protected getMainElementClasses(): Array<string>{
        return ["promo-style", "page-content"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            processingToken: ko.observable("block"),
            invalidToken: ko.observable("none"),
            optOutComplete: ko.observable("none"),
        };
    }

    public getViewModelForRequest(): Object{

        return {
        };
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/notificationOptOut_template.ts